import { computed } from 'vue'
import { getActiveChatModule } from '@/environment/environment'
import { useEmbeddedChatSetup as useMatrixEmbeddedChatSetup } from '@/modules/chat-matrix-fast/composables/useEmbeddedChatSetup'
import { useSlidingChatGlobal as useMatrixSlidingChatGlobal } from '@/modules/chat-matrix-fast/composables/useSlidingChatGlobal'
import { useChatStore as useMatrixChatStore } from '@/modules/chat-matrix-fast/stores/chatStore'
import { resetMatrixChatStores } from '@/modules/chat-matrix-fast/services/matrixChatCleanup'

export type {
  IUseEmbeddedChatSetupParams,
  IUseEmbeddedChatSetupReturn,
} from '@/modules/chat-matrix-fast/composables/useEmbeddedChatSetup'

export function getChatAppPath(): string {
  return '/messenger'
}

const slidingChatStub = {
  isSlidingChatVisible: computed(() => false),
  slidingChatInitialChatId: computed(() => null as number | null),
  slidingChatInitialUserId: computed(() => null as string | null),
  openSlidingChat: (_?: number | null, __?: string | null) => {},
  closeSlidingChat: () => {},
}

export function useSlidingChatGlobalBridge() {
  return getActiveChatModule() === 'matrix'
    ? useMatrixSlidingChatGlobal()
    : slidingChatStub
}

export function useChatStoreCoreBridge() {
  return useMatrixChatStore()
}

/** Фоновая синхронизация после авторизации для выбранного Matrix-клиента. */
export function initGlobalChatSync(): void {
  if (getActiveChatModule() !== 'matrix') {
    return
  }

  void useMatrixChatStore().initializeOnce()
}

/** Останавливает синхронизацию Matrix-клиента при выходе. */
export function resetGlobalChatSync(): void {
  if (getActiveChatModule() === 'matrix') {
    void resetMatrixChatStores()
  }
}

/** Чат в карточках сущностей; без фичи Matrix подключение отключено. */
export function useEmbeddedChatSetup(
  params: Parameters<typeof useMatrixEmbeddedChatSetup>[0],
) {
  if (getActiveChatModule() === 'matrix') {
    return useMatrixEmbeddedChatSetup(params)
  }

  return useMatrixEmbeddedChatSetup({
    ...params,
    chatEnabled: computed(() => false),
  })
}
